/**
 * Provider que ativa a sincronização automática com Google Calendar
 * quando o usuário estiver logado e com a funcionalidade habilitada.
 */

import { useGoogleCalendarAutoSync } from '../hooks/useGoogleCalendarAutoSync'

interface Props {
  children: React.ReactNode
}

export function GoogleCalendarAutoSyncProvider({ children }: Props) {
  // O hook já cuida de verificar se o usuário está conectado e se o auto-sync está ativado
  useGoogleCalendarAutoSync()

  return <>{children}</>
}
